module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/points/point_08-fb28001be850c06c088ddff1f6266a09.svg";